/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "../configuration";
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from "axios";
import globalAxios from "axios";
import { useAuthStore } from "@/stores/auth";
import { useClient } from "@/composables/useClient";
import { useNotificationStore } from "@/stores/notification";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  propertyMeta,
  MetaTypesBase,
} from "../common";
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from "../base";
// @ts-ignore
import type { APEligibleClass } from "../model";
import { APEligibleClassTrackedI, APEligibleClassMeta } from "../model";
// @ts-ignore
import type { APFutureClass } from "../model";
import { APFutureClassTrackedI, APFutureClassMeta } from "../model";
// @ts-ignore
import type { DummyEnum } from "../model";
import { DummyEnumTrackedI, DummyEnumMeta } from "../model";
// @ts-ignore
import type { ModelBoolean } from "../model";
import { ModelBooleanTrackedI, ModelBooleanMeta } from "../model";
// @ts-ignore
import type { PrinterInternalDTO } from "../model";
import { PrinterInternalDTOTrackedI, PrinterInternalDTOMeta } from "../model";
import { applyTransform } from "@/api/mappers/dtoDateMapper";
import { PaginatedResults } from "@/api/models/PaginatedResults";
/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Gets eligible class information for the supplied person_id
     * @summary Get eligible classes
     * @param {number} personId The person id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apClassGetEligiblePersonIdGet: (
      personId: number,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      // verify required parameter 'personId' is not null or undefined
      assertParamExists("apClassGetEligiblePersonIdGet", "personId", personId);
      const localVarPath = `/ap-class/get-eligible/{personId}`.replace(
        `{${"personId"}}`,
        encodeURIComponent(String(personId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Gets eligible class information for the supplied person_id
     * @summary Get eligible classes
     * @param {number} personId The person id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apClassGetFuturePersonIdGet: (
      personId: number,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      // verify required parameter 'personId' is not null or undefined
      assertParamExists("apClassGetFuturePersonIdGet", "personId", personId);
      const localVarPath = `/ap-class/get-future/{personId}`.replace(
        `{${"personId"}}`,
        encodeURIComponent(String(personId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Tests Post.
     * @summary Test
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberGetNoParamsGet: (
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      const localVarPath = `/member/getNoParams`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pathsDummyDtoGet: (
      id: number,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("pathsDummyDtoGet", "id", id);
      const localVarPath = `/paths/dummyDto`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      if (id !== undefined) {
        localVarQueryParameter["id"] = id;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pathsDummyEnumGet: (
      id: number,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("pathsDummyEnumGet", "id", id);
      const localVarPath = `/paths/dummyEnum`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      if (id !== undefined) {
        localVarQueryParameter["id"] = id;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

export type apClassGetEligiblePersonIdGetParams = { personId: number };
export type apClassGetFuturePersonIdGetParams = { personId: number };
export type memberGetNoParamsGetParams = {};
export type pathsDummyDtoGetParams = { id: number };
export type pathsDummyEnumGetParams = { id: number };

export const apClassGetEligiblePersonIdGetMeta = {
  personId: propertyMeta("personId", false, true, false, MetaTypesBase.number),
};
export const apClassGetFuturePersonIdGetMeta = {
  personId: propertyMeta("personId", false, true, false, MetaTypesBase.number),
};
export const memberGetNoParamsGetMeta = {};
export const pathsDummyDtoGetMeta = {
  id: propertyMeta("id", false, true, false, MetaTypesBase.number),
};
export const pathsDummyEnumGetMeta = {
  id: propertyMeta("id", false, true, false, MetaTypesBase.number),
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const useDefaultApi = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration);
  const client = useClient();
  const authStore = useAuthStore();
  const notificationStore = useNotificationStore();
  return {
    /**
     * Gets eligible class information for the supplied person_id
     * @summary Get eligible classes
     * @param {number} personId The person id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apClassGetEligiblePersonIdGetRaw(
      props: apClassGetEligiblePersonIdGetParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<APEligibleClass> {
      authStore.requireAuth([
        // authentication member required
        "member",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.apClassGetEligiblePersonIdGet(
          props.personId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.apClassGetEligiblePersonIdGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<APEligibleClass>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("APEligibleClass", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Gets eligible class information for the supplied person_id
     * @summary Get eligible classes
     * @param {number} personId The person id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apClassGetFuturePersonIdGetRaw(
      props: apClassGetFuturePersonIdGetParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<APFutureClass> {
      const localVarAxiosArgs =
        localVarAxiosParamCreator.apClassGetFuturePersonIdGet(
          props.personId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.apClassGetFuturePersonIdGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<APFutureClass>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("APFutureClass", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Tests Post.
     * @summary Test
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberGetNoParamsGetRaw(
      props: memberGetNoParamsGetParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ModelBoolean> {
      const localVarAxiosArgs =
        localVarAxiosParamCreator.memberGetNoParamsGet(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.memberGetNoParamsGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<ModelBoolean>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("ModelBoolean", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pathsDummyDtoGetRaw(
      props: pathsDummyDtoGetParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PrinterInternalDTO> {
      const localVarAxiosArgs = localVarAxiosParamCreator.pathsDummyDtoGet(
        props.id,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.pathsDummyDtoGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<PrinterInternalDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("PrinterInternalDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pathsDummyEnumGetRaw(
      props: pathsDummyEnumGetParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<DummyEnum> {
      const localVarAxiosArgs = localVarAxiosParamCreator.pathsDummyEnumGet(
        props.id,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.pathsDummyEnumGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<DummyEnum>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("DummyEnum", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },

    /**
     * Gets eligible class information for the supplied person_id
     * @summary Get eligible classes
     * @param {number} personId The person id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apClassGetEligiblePersonIdGet(
      personId: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<APEligibleClass> {
      authStore.requireAuth([
        // authentication member required
        "member",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.apClassGetEligiblePersonIdGet(
          personId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.apClassGetEligiblePersonIdGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<APEligibleClass>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("APEligibleClass", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Gets eligible class information for the supplied person_id
     * @summary Get eligible classes
     * @param {number} personId The person id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apClassGetFuturePersonIdGet(
      personId: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<APFutureClass> {
      const localVarAxiosArgs =
        localVarAxiosParamCreator.apClassGetFuturePersonIdGet(
          personId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.apClassGetFuturePersonIdGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<APFutureClass>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("APFutureClass", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Tests Post.
     * @summary Test
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberGetNoParamsGet(
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ModelBoolean> {
      const localVarAxiosArgs =
        localVarAxiosParamCreator.memberGetNoParamsGet(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.memberGetNoParamsGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<ModelBoolean>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("ModelBoolean", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pathsDummyDtoGet(
      id: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PrinterInternalDTO> {
      const localVarAxiosArgs = localVarAxiosParamCreator.pathsDummyDtoGet(
        id,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.pathsDummyDtoGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<PrinterInternalDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("PrinterInternalDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    pathsDummyEnumGet(
      id: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<DummyEnum> {
      const localVarAxiosArgs = localVarAxiosParamCreator.pathsDummyEnumGet(
        id,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.pathsDummyEnumGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<DummyEnum>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("DummyEnum", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
  };
};

/**
 * DefaultApi - interface
 * @export
 * @interface DefaultApi
 */
export interface DefaultApiInterface {
  /**
   * Gets eligible class information for the supplied person_id
   * @summary Get eligible classes
   * @param {number} personId The person id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApiInterface
   */
  apClassGetEligiblePersonIdGet(
    personId: number,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<APEligibleClass>;

  /**
   * Gets eligible class information for the supplied person_id
   * @summary Get eligible classes
   * @param {number} personId The person id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApiInterface
   */
  apClassGetFuturePersonIdGet(
    personId: number,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<APFutureClass>;

  /**
   * Tests Post.
   * @summary Test
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApiInterface
   */
  memberGetNoParamsGet(
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ModelBoolean>;

  /**
   *
   * @param {number} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApiInterface
   */
  pathsDummyDtoGet(
    id: number,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<PrinterInternalDTO>;

  /**
   *
   * @param {number} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApiInterface
   */
  pathsDummyEnumGet(
    id: number,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<DummyEnum>;
}
